import * as Yup from 'yup'

export const ChatMessageSchema = Yup.object().shape({
  senderId: Yup.string().label('Sender ID').required(),
  tagIds: Yup.array().of(Yup.string()),
  message: Yup.string().label('Message').trim().required(),
})
